/**
 * 登录页面
 */

import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';

const { Title, Text } = Typography;

interface LoginForm {
    username: string;
    password: string;
}

const Login: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // 获取登录前的页面，登录后跳转回去
    const from = (location.state as any)?.from?.pathname || '/';

    const handleSubmit = async (values: LoginForm) => {
        setLoading(true);
        try {
            const success = await login(values.username, values.password);
            if (success) {
                navigate(from, { replace: true });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <Card className="login-card">
                <div className="login-header">
                    <Title level={2} className="login-title">
                        Amazon 市场智能分析
                    </Title>
                    <Text type="secondary">请登录您的账号</Text>
                </div>

                <Form
                    name="login"
                    onFinish={handleSubmit}
                    autoComplete="off"
                    size="large"
                >
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: '请输入用户名' }]}
                    >
                        <Input
                            prefix={<UserOutlined />}
                            placeholder="用户名"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: '请输入密码' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder="密码"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            block
                        >
                            登录
                        </Button>
                    </Form.Item>
                </Form>

                <div className="login-footer">
                    <Button type="link" onClick={() => navigate('/register')}>
                        注册新账号
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default Login;
